import React from 'react';
import PropTypes from 'prop-types';
import { PricePromiseTable, TAB } from './PricePromiseTable.jsx';
import { canExpand, getDisplayedTable } from './common.js';
import pricePromiseAnalytics from './pricePromiseAnalytics.js';
import uiLocale from '../../../utils/UILocale.js';

const MAX_ROWS_COLLAPSED = 5;


export default class PricePromiseTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    };
  }

  componentDidMount() {
    pricePromiseAnalytics(this.props.competitorsTable, this.props.exclusive);
  }

  render() {

    const NO_DATA_TEXT = uiLocale.getString('component.price-promise.no-data');
    const EXCLUSIVE_TEXT = uiLocale.getString('component.price-promise.exclusive');
    const HEADER_PREFIX = uiLocale.getString('component.price-promise.price-comparison-for');
    const SHOW_MORE_TEXT = uiLocale.getString('component.price-promise.show-more');


    const { productName, exclusive } = this.props;
    const competitorsTable = exclusive ? [] : this.props.competitorsTable;

    const expanded = this.state.expanded || this.props.expanded;
    const noData = !exclusive && !competitorsTable.length;

    const showButton = canExpand(competitorsTable, expanded, MAX_ROWS_COLLAPSED);
    const table = getDisplayedTable(competitorsTable, expanded, MAX_ROWS_COLLAPSED);

    let tooltipText;
    if (noData) {
      tooltipText = NO_DATA_TEXT;
    } else if (exclusive) {
      tooltipText = EXCLUSIVE_TEXT;
    }

    return (
      <div>
        <h5 className={'price-promise-tab-header'}>{ `${HEADER_PREFIX} ${productName}` }</h5>

        { !!tooltipText && (
        <div className={'price-promise-tab-header-separator'}>
          <span className={'inline-tooltip'}>{ tooltipText }</span>
        </div>
        )}

        <PricePromiseTable table={table} location={TAB} />

        { showButton && (
        <button
          className={'bt btn-secondary outline price-promise-tab-show-more'}
          onClick={() => this.setState({ expanded: true })}
        >
          { SHOW_MORE_TEXT }
        </button>
        )}
      </div>
    );
  }
}

PricePromiseTab.propTypes = {
  productName: PropTypes.string.isRequired,
  exclusive: PropTypes.bool.isRequired,
  competitorsTable: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  expanded: PropTypes.bool
};

PricePromiseTab.defaultProps = {
  expanded: false
};
